import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";

export default async function updateBookshelfEquipmentFiles(equipmentId, filesBase64, finalFilesIds, prefix) {
    const token = await getOrRefreshFirebaseToken();

    const formData = new FormData();
    if (!Array.isArray(filesBase64) || filesBase64.length === 0) {
        formData.append('files', ''); // Handle case with no files
    }
    else {
        filesBase64.forEach((file) => {
            formData.append('files', file);
        });
    }
    finalFilesIds.forEach((id) => {
        formData.append('finalFilesIds', id);
    });

    const res = await fetch(
        `${prefix}bookshelf/equipment/${equipmentId}/files`,
        {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: formData,
        }
    );
    
    return res.json();
}